import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
  name: 'utcToTimezone'
})
export class UtcToTimezonePipe implements PipeTransform {

  transform(
    value: string | Date, 
    timeZone: string = 'America/New_York', 
    format: string = 'YYYY-MM-DD hh:mm A'
  ): string {
    if (!value) return '';

    return dayjs(value).tz(timeZone).format(format);
  }

}
